import { routes as agendas } from './agendas'
import { routes as locks } from './locks'
import { routes as rules } from './rules'

export default [
  ...agendas,
  ...locks,
  ...rules
]



// WEBPACK FOOTER //
// ./src/app/professional/agenda/routes.js